import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { IOnboardingGuideStep } from '../../fi-onboarding';

@Component({
    selector: 'fi-onboarding-editor-guide-card',
    templateUrl: './fi-onboarding-editor-guide-card.component.html',
    styleUrls: ['./fi-onboarding-editor-guide-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-editor-guide-card' },
    standalone: false,
})
export class FiOnboardingEditorGuideCardComponent {
    protected readonly guideSteps: IOnboardingGuideStep[] = [
        {
            Name: 'onboarding.name',
            Description: 'onboarding.name_guide_description',
        },
        {
            Name: 'checklist.section_new',
            Description: 'onboarding.add_section_guide_description',
        },
        {
            Name: 'onboarding.section_options',
            Description: 'onboarding.section_options_guide_description',
        },
        {
            Name: 'onboarding.add_step',
            Description: 'onboarding.add_step_guide_description',
        },
        {
            Name: 'onboarding.step_options',
            Description: 'onboarding.step_options_guide_description',
        },
        {
            Name: 'onboarding.step_add_element',
            Description: 'onboarding.step_add_element_guide_description',
        },
    ];
}
